import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import ModalController from './ui/Modal/ModalController';
import Overlay from './components/Overley/Overlay';
import './index.css';
import PopoverController from './ui/Popover/PopoverController';
import { loadTasks } from './services/task';
import { loadSkills } from './services/skill';
import TooltipController from './ui/Tooltip/TooltipController';
import NotificationController from './ui/Notification/NotificationController';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

ReactDOM.render(
  <React.StrictMode>
    <Overlay />
  </React.StrictMode>,
  document.getElementById('root-overlay')
);

ReactDOM.render(
  <React.StrictMode>
    <ModalController />
  </React.StrictMode>,
  document.getElementById('root-modal')
);

ReactDOM.render(
  <React.StrictMode>
    <PopoverController />
  </React.StrictMode>,
  document.getElementById('root-dropper')
);

ReactDOM.render(
  <React.StrictMode>
    <TooltipController />
  </React.StrictMode>,
  document.getElementById('root-tooltip')
);

ReactDOM.render(
  <React.StrictMode>
    <NotificationController />
  </React.StrictMode>,
  document.getElementById('root-notification')
);

// @ts-ignore
onLoadComplete();
loadSkills();
loadTasks();